/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_LostInputs */

const th_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พ`)
};

const en_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L`)
};

const ja_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`敗`)
};

const zh_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`负`)
};

const es_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`P`)
};

const pt_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`D`)
};

const id_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`K`)
};

const fr_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`D`)
};

const tl_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T`)
};

const vi_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T`)
};

const ko_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`패`)
};

const de_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N`)
};

const ru_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`П`)
};

const tr_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M`)
};

const it_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`P`)
};

const pl_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`P`)
};

const uk_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`П`)
};

const hi_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हा`)
};

const ar_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خ`)
};

const ms_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`K`)
};

const bn_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হা`)
};

const zh_tw2_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`敗`)
};

const zh_hk2_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`敗`)
};

const ur_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ہا`)
};

const fa_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ب`)
};

const sw_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`P`)
};

const nl_col_lost = /** @type {(inputs: Col_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V`)
};

/**
* | output |
* | --- |
* | "L" |
*
* @param {Col_LostInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const col_lost = /** @type {((inputs?: Col_LostInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_LostInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_col_lost(inputs)
	if (locale === "ja") return ja_col_lost(inputs)
	if (locale === "zh") return zh_col_lost(inputs)
	if (locale === "es") return es_col_lost(inputs)
	if (locale === "pt") return pt_col_lost(inputs)
	if (locale === "id") return id_col_lost(inputs)
	if (locale === "fr") return fr_col_lost(inputs)
	if (locale === "tl") return tl_col_lost(inputs)
	if (locale === "vi") return vi_col_lost(inputs)
	if (locale === "ko") return ko_col_lost(inputs)
	if (locale === "de") return de_col_lost(inputs)
	if (locale === "ru") return ru_col_lost(inputs)
	if (locale === "tr") return tr_col_lost(inputs)
	if (locale === "it") return it_col_lost(inputs)
	if (locale === "pl") return pl_col_lost(inputs)
	if (locale === "uk") return uk_col_lost(inputs)
	if (locale === "hi") return hi_col_lost(inputs)
	if (locale === "ar") return ar_col_lost(inputs)
	if (locale === "ms") return ms_col_lost(inputs)
	if (locale === "bn") return bn_col_lost(inputs)
	if (locale === "zh-TW") return zh_tw2_col_lost(inputs)
	if (locale === "zh-HK") return zh_hk2_col_lost(inputs)
	if (locale === "ur") return ur_col_lost(inputs)
	if (locale === "fa") return fa_col_lost(inputs)
	if (locale === "sw") return sw_col_lost(inputs)
	if (locale === "nl") return nl_col_lost(inputs)
	return en_col_lost(inputs)
});